module.exports = __webpack_public_path__ + "static/hakualue-beda67dacce535400c1ec78e04817d5f.png";